import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLink = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0714 2.58465C10.8857 2.39884 10.6652 2.25145 10.4225 2.15089C10.1798 2.05033 9.91963 1.99857 9.65692 1.99857C9.39421 1.99857 9.13407 2.05033 8.89137 2.15089C8.64866 2.25145 8.42815 2.39884 8.24242 2.58465L6.12142 4.70765L4.70742 3.29165L6.82842 1.17165C7.19986 0.80019 7.64082 0.505533 8.12614 0.304502C8.61145 0.10347 9.13161 0 9.65692 0C10.1822 0 10.7024 0.10347 11.1877 0.304502C11.673 0.505533 12.114 0.80019 12.4854 1.17165L13.1924 1.87765L13.1024 1.96765C13.553 2.73142 13.737 3.62325 13.6255 4.50298C13.514 5.3827 13.1133 6.20044 12.4864 6.82765L10.3654 8.94865L8.95042 7.53465L11.0724 5.41365C11.2582 5.22792 11.4056 5.0074 11.5062 4.7647C11.6067 4.522 11.6585 4.26186 11.6585 3.99915C11.6585 3.73643 11.6067 3.4763 11.5062 3.23359C11.4056 2.99089 11.2582 2.77037 11.0724 2.58465H11.0714ZM2.58542 11.0706C2.77115 11.2564 2.99166 11.4038 3.23437 11.5044C3.47707 11.605 3.73721 11.6567 3.99992 11.6567C4.26263 11.6567 4.52277 11.605 4.76547 11.5044C5.00818 11.4038 5.22869 11.2564 5.41442 11.0706L7.53542 8.94865L8.94942 10.3636L6.82842 12.4826C6.45698 12.8541 6.01602 13.1488 5.5307 13.3498C5.04539 13.5508 4.52522 13.6543 3.99992 13.6543C3.47462 13.6543 2.95445 13.5508 2.46914 13.3498C1.98382 13.1488 1.54286 12.8541 1.17142 12.4826L0.46442 11.7766L0.55442 11.6866C0.104113 10.923 -0.0797324 10.0313 0.0317673 9.15184C0.143267 8.27233 0.543793 7.45479 1.17042 6.82765L3.29142 4.70665L4.70842 6.12065L2.58542 8.24165C2.39962 8.42737 2.25223 8.64789 2.15167 8.89059C2.05111 9.1333 1.99935 9.39343 1.99935 9.65615C1.99935 9.91886 2.05111 10.179 2.15167 10.4217C2.25223 10.6644 2.39962 10.8849 2.58542 11.0706Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.656 5.414L8.242 4L4 8.242L5.414 9.656L9.656 5.414Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgLink);
export { ForwardRef as ReactComponent };
